import { HiOutlineInformationCircle } from 'react-icons/hi'

import { Alert, Icon, SlideFade, Text } from '@chakra-ui/react'

interface AiOperatorNoCriteriaBannerIProps {
  hasNoCriterion: boolean
  message?: string
}
export const AiOperatorNoCriteriaBanner = ({
  hasNoCriterion,
  message = 'Please add a criteria to Enable AI Operator',
}: AiOperatorNoCriteriaBannerIProps) => {
  return (
    <SlideFade in={hasNoCriterion}>
      <Alert borderRadius='xl' mb={4} px={4} status='error' width='100%'>
        <Icon
          as={HiOutlineInformationCircle}
          boxSize='20px'
          color='red.600'
          mr='10px'
        />
        <Text color='red.600' fontSize='sm' fontWeight='medium'>
          {message}
        </Text>
      </Alert>
    </SlideFade>
  )
}
